export function range(length: number): number[] {
  return Array.from({ length }, (_element, index) => index)
}
